import { IGoogleReviewSummary } from "api/interfaces/google-reviews.type";
import { IHomePage } from "api/interfaces/home/home.type";
import { IPageContent } from "api/interfaces/static-content.type";
import Element from "component/design-system/react-scroll/components/Element";
import dynamic from "next/dynamic";
import { memo } from "react";
import HideIf from "util/HideIf";
import BannerWrapper from "./BannerWrapper";
import HomeContent from "./HomeContent";
import AboutPA from "./about-pa/AboutPA";
import styles from "./home.module.scss";
import HomeGarage from "./homeGarage/HomeGarage";
import HomeMetaHeader from "./meta/HomeMetaHeader";

const FullWidthSection = dynamic(() => import(/* webpackChunkName: "full-width-section" */ "./FullwidthSection"));
const Breadcrumbs = dynamic(() => import(/* webpackChunkName: "breadcrumbs" */ "modules/product/header/Breadcrumbs"));

interface IProps {
  homeJson: IHomePage;
  googleReviewSummary: IGoogleReviewSummary;
  showBreadCrumb?: boolean;
  staticContent: IPageContent;
  showFullWidthSection: boolean;
}

function Home(props: IProps) {
  const {
    homeJson, googleReviewSummary, showBreadCrumb, staticContent, contentIds, meta, showFullWidthSection,
  } = props;

  const { bannersWebp, googleReviews, highTrafficPageData } = homeJson || {};
  const { overallRating, totalReviews } = googleReviewSummary || {};

  return (
    <div className={styles.home}>
      {/* first fold of page are not in renderChild, to solve CLS and FCP and LCP  */}

      <HomeMetaHeader
        reviews={googleReviews}
        aggregateRating={overallRating}
        totalReviews={totalReviews}
        contentIds={contentIds}
        meta={meta}
      />

      <BannerWrapper
        bannersWebp={bannersWebp}
      />

      <div className={`container-fluid ${styles.homeContainer}`} data-clarity-unmask="true">
        <Element name="anchor-top" />
        <div className={styles.mobile_garage}>
          <HomeGarage />
        </div>
        <HideIf show={showBreadCrumb}>
          <Breadcrumbs
            staticContent={staticContent}
            className={styles.breadcrumbs}
          />
        </HideIf>

        <HomeContent
          {...{ homeJson }}
        />
      </div>

      <AboutPA AboutPAContent={highTrafficPageData?.About_PA} />

      {showFullWidthSection ? <FullWidthSection /> : null }
    </div>
  );
}

export default memo(Home);
